import type { USER_ROLE_WITHOUT_GUEST_AND_USER } from 'cpool-constants';

import type { ManagementTab } from '~/components/Header/navigation/subRoutes/managementTabs';
import { managementTabs } from '~/components/Header/navigation/subRoutes/managementTabs';

export const getVisibleManagementTabs = (role: USER_ROLE_WITHOUT_GUEST_AND_USER | undefined): Array<ManagementTab> =>
    role ? managementTabs.filter((tab) => tab.roles.includes(role)) : [];
